import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import MuiBox from '@mui/material/Box';
import Tooltip from '../Tooltip/Tooltip.js';

const _LinearProgress = styled(LinearProgress) `
  ${({ value, variant }) => variant === 'determinate' &&
    `
    overflow: visible;
    .MuiLinearProgress-bar {
      width: ${value}%;
    }
  `}
`;
const Root = styled(MuiBox) `
  width: 100%;
  &:hover {
    .MuiLinearProgress-bar {
      height: 4px;
      top: -50%;
    }
  }
  ${({ theme }) => `
    padding: ${theme.spacing(1)};
  `}
`;
const ProgressIndicator = (_a) => {
    var { hint, hintDuration, className, value = 0 } = _a, rest = __rest(_a, ["hint", "hintDuration", "className", "value"]);
    return (jsx(Tooltip, Object.assign({ title: hint, duration: hintDuration, placement: "top" }, { children: jsx(Root, Object.assign({ className: className }, { children: jsx(_LinearProgress, Object.assign({ variant: "determinate", value: value }, rest)) })) })));
};

export { ProgressIndicator as default };
//# sourceMappingURL=ProgressIndicator.js.map
